<template>
    <div v-if="model && viewHistoryMammography">

        <v-row dense class="mt-2" justify="center">
            <v-col cols="12" sm="12" md="12">
                <v-banner color="blue-grey lighten-5" class="mb-4 black--text" shaped single-line>
                    Antecedentes de mastografía
                </v-banner>
            </v-col>
            <v-col cols="4" md="4" sm="12" justify="center">
                <strong class="mr-2">Fecha de última mastografía: </strong>
                {{ (model.dateStudy ? $utilFront.formatDate(model.dateStudy) : '- - -') }}
            </v-col>

            <v-col cols="4" md="4" sm="12" justify="center">
                <strong class="mr-2">BI-RADS: </strong>
                {{ model.birads ? model.birads.name : '- - -' }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import StudyBackgroundRequest from "@/core/request/StudyBackgroundRequest";


export default {
    name: "StudyBackground",
    props: {
        parameters: Object,
    },
    data() {
        return {
            model: null,
            viewHistoryMammography: false
        };
    },
    mounted() {
        this.getData();
    },

    methods: {
        getData() {

            let {nameStudy, nameModality} = this.parameters;
            this.viewHistoryMammography = this.$cnst.IS_MOMMOGRAPHY(nameStudy) || this.$cnst.IS_MOMMOGRAPHY(nameModality);

            StudyBackgroundRequest.findBackgroundByStudy(this.parameters.idStudy).then((response) => {
                const { data } = response.data;
                this.model = data || null;
            });
        },
    },
};
</script>

<style></style>
